import { RelatorioNucleoDto, RelatorioNucleoLotacaoDto } from '@/api.types';
import { TipoLotacaoCompletaList } from '@/shared/constants/enumlist';
import { DataAmigavel } from '@/shared/utils/datas';

function formatarDataOuInfinito(
  data: string | Date | null | undefined,
  semData: string,
): string {
  if (data == null || String(data).trim() === '') return semData;
  return DataAmigavel(data) || semData;
}

export function tituloVigenciaLotacao(lotacao: RelatorioNucleoLotacaoDto): string {
  const tipo =
    TipoLotacaoCompletaList.find((item) => item.value === lotacao.tipo)?.name ??
    'Lotação';

  const linhas = [
    `${tipo} ${lotacao.id}`,
    `Lotação: ${formatarDataOuInfinito(lotacao.data_inicial, 'sem início')} até ${formatarDataOuInfinito(lotacao.data_final, 'sem fim')}`,
  ];

  if (lotacao.estagio) {
    const inicio = formatarDataOuInfinito(
      lotacao.estagio.data_inicio_estagio,
      'sem início',
    );
    const fimEstagio = formatarDataOuInfinito(
      lotacao.estagio.data_fim_estagio,
      'sem fim',
    );
    linhas.push(`Estágio: ${inicio} até ${fimEstagio}`);
  }

  return linhas.join('\n');
}

function nomeEstagiarioLotacao(lotacao: RelatorioNucleoLotacaoDto): string {
  return (
    lotacao.estagio?.estagiario?.pessoa?.nome ||
    (lotacao.estagio?.estagiario as { nome?: string } | undefined)?.nome ||
    ''
  );
}

function nomeDefensorLotacao(lotacao: RelatorioNucleoLotacaoDto): string {
  return lotacao.defensor?.pessoa?.nome || '';
}

function compararNomePtBr(a: string, b: string): number {
  return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' });
}

export function ordenarLotacoesEstagiarioPorNome(
  lotacoes: RelatorioNucleoLotacaoDto[],
): RelatorioNucleoLotacaoDto[] {
  return [...lotacoes].sort((a, b) =>
    compararNomePtBr(nomeEstagiarioLotacao(a), nomeEstagiarioLotacao(b)),
  );
}

export function ordenarLotacoesDefensorPorTitular(
  lotacoes: RelatorioNucleoLotacaoDto[],
): RelatorioNucleoLotacaoDto[] {
  return [...lotacoes].sort((a, b) => {
    const titularA = a.diretor ? 1 : 0;
    const titularB = b.diretor ? 1 : 0;
    if (titularA !== titularB) return titularB - titularA;
    return compararNomePtBr(nomeDefensorLotacao(a), nomeDefensorLotacao(b));
  });
}

export function filtrarNucleosComEstagiarios(
  nucleos: RelatorioNucleoDto[],
): RelatorioNucleoDto[] {
  return nucleos
    .map((nucleo) => ({
      ...nucleo,
      lotacoes: ordenarLotacoesEstagiarioPorNome(
        (nucleo.lotacoes ?? []).filter((lotacao) => !!lotacao.estagio),
      ),
    }))
    .filter((nucleo) => nucleo.lotacoes.length > 0);
}
